export type QuickTipsTranslation = {
  processDetailsAction: string;
  processDetailsActionTitle: string;
  quickTips: string;
  toggleRequirements: string;
  toggleRequirementsTitle: string;
};

export const quickTipsTranslation: QuickTipsTranslation = {
  processDetailsAction:
    'To quickly view the full details of a recruitment process, click on the "View" button in the Action column. This will open the detailed page where you can explore all information related to the selected process.',
  processDetailsActionTitle: 'Using the Action Column to Navigate to Process Details',
  quickTips: 'Quick Tips',
  toggleRequirements:
    'If the requirements column shows truncated content, click the expansion option to view the full list of qualifications and skills needed for the position. This allows you to fully review the process criteria at a glance.',
  toggleRequirementsTitle: 'Expanding Requirements for More Information',
};
